import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  href?: string;
  text?: string;
  limitText?: string;
  hideLimitText?: boolean;
  className?: string;
}
export function CTAButton({
  href = 'https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc.',
  text = 'Rezervă Sesiunea Gratuită de Evaluare',
  limitText = '*locuri limitate',
  hideLimitText = false,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center gap-2 ${className}`} data-id="element-351">
      <a href={href} target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-cream font-heading font-semibold text-lg px-8 py-4 rounded-full hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-352">
        {text}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-353" />
      </a>
      {!hideLimitText && <span className="text-sm font-subtitle italic text-brand-textSec" data-id="element-354">
          {limitText}
        </span>}
    </div>;
}